module.exports = __webpack_public_path__ + "static/img/noQuickAnswer.00812566.png";